/**

 * LOTI Games and Apps — company splash (MP4 + audio) before the tutor UI.

 *

 * Place file exactly at:

 *   piano_tutor_web/public/splash/loti-intro.mp4

 * Served as ./splash/loti-intro.mp4 (web + Electron).

 * Missing file → splash skips and app opens.

 *

 * Audio: try unmuted first (Electron / user-gesture contexts).

 * If autoplay blocks sound, show Tap for sound and unmute on first interaction.

 */



const SPLASH_URL = "./splash/loti-intro.mp4";

// The encoded intro is exactly 5s; this guard only prevents a boot hang if
// a browser fails to emit `ended`.
const MAX_MS = 6500;

const FADE_MS = 450;



export async function runCompanySplash(): Promise<void> {

  const root = document.querySelector<HTMLElement>("#company-splash");

  const video = document.querySelector<HTMLVideoElement>("#splash-video");

  const skipBtn = document.querySelector<HTMLButtonElement>("#splash-skip");

  const soundBtn = document.querySelector<HTMLButtonElement>("#splash-sound");

  if (!root || !video) return;



  let finished = false;



  const finish = () => {

    if (finished) return;

    finished = true;

    try {

      video.pause();

    } catch {

      /* */

    }

    root.classList.add("is-done");

    window.setTimeout(() => {

      root.hidden = true;

      root.setAttribute("aria-hidden", "true");

      document.body.classList.remove("boot-splash");

      const app = document.querySelector<HTMLElement>("#app");

      if (app) {

        app.hidden = false;

        app.removeAttribute("aria-hidden");

      }

    }, FADE_MS);

  };



  const enableSound = async () => {

    video.muted = false;

    video.volume = 1;

    try {

      await video.play();

    } catch {

      /* */

    }

    if (soundBtn) soundBtn.hidden = true;

    root.classList.remove("needs-sound");

  };



  skipBtn?.addEventListener("click", finish, { once: true });

  soundBtn?.addEventListener(

    "click",

    (e) => {

      e.stopPropagation();

      void enableSound();

    },

    { once: true },

  );



  const unlockSoundOnce = () => {

    if (finished || !video.muted) return;

    void enableSound();

  };

  root.addEventListener("pointerdown", unlockSoundOnce, { once: true });

  window.addEventListener(

    "keydown",

    (e) => {

      if (e.key === "Escape") {

        e.preventDefault();

        finish();

        return;

      }

      if (e.key === "Enter" || e.key === " ") {

        e.preventDefault();

        if (video.muted) unlockSoundOnce();

        else finish();

      }

    },

    { once: true },

  );



  video.addEventListener("ended", finish, { once: true });

  video.addEventListener("error", finish, { once: true });



  try {

    const head = await fetch(SPLASH_URL, { method: "HEAD", cache: "no-cache" });

    if (!head.ok) {

      const probe = await fetch(SPLASH_URL, { cache: "no-cache" });

      if (!probe.ok) {

        finish();

        return;

      }

    }

  } catch {

    // Offline/file:// quirks — still try playing

  }



  video.src = SPLASH_URL;

  video.playsInline = true;

  video.muted = false;

  video.volume = 1;



  try {

    await video.play();

    if (soundBtn) soundBtn.hidden = true;

  } catch {

    // Autoplay with sound blocked — play muted, invite tap for audio

    video.muted = true;

    root.classList.add("needs-sound");

    if (soundBtn) soundBtn.hidden = false;

    try {

      await video.play();

    } catch {

      // Leave poster; user can Skip

    }

  }



  window.setTimeout(finish, MAX_MS);

}


